import { useState, useEffect, useCallback } from "react";

interface Photo {
  id: number;
  url: string;
  alt: string;
}

interface Category {
  label: string;
  photos: Photo[];
}

const categories: Category[] = [
  {
    label: "누수현장",
    photos: [
      { id: 1, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/dbe7649c383b52b9682aa34391ea4bba.jpeg", alt: "욕실 배관 누수 수리 현장" },
      { id: 2, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/a49b5dde4d394124d7abeadb5627ca79.jpeg", alt: "변기 하부 누수 현장" },
      { id: 3, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/66b1f2285fd3c3e40a0dac106b65e741.jpeg", alt: "누수탐지 장비" },
      { id: 4, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/232aa8cf1bc9733207a676b6a4a39467.jpeg", alt: "배관 점검 드릴 작업" },
      { id: 5, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/3be09b3982d24be51dcb559de32dbfad.jpeg", alt: "음파 누수탐지 작업" },
      { id: 6, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/cd8be6ebf62b87593592529debc8d0e8.jpeg", alt: "전자 누수탐지 장비 사용" },
      { id: 7, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/dd10f84143efef7cb0828ac0dc70442e.jpeg", alt: "배관 연결부 점검" },
      { id: 8, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/bf422bf6549fd76021b551f39977272f.jpeg", alt: "천장 누수 점검" },
    ],
  },
  {
    label: "방수",
    photos: [
      { id: 1, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/48d168bfefe2a1ddca0baa347c78dfa5.jpeg", alt: "방수 코팅 작업" },
      { id: 2, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/bc40a3a3ae483e66753edb3fdef94e52.jpeg", alt: "방수층 손상 현장" },
      { id: 3, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/4d82ed5ca23c2eca6272ec95892110a9.jpeg", alt: "배수구 방수 처리" },
      { id: 4, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/f117b1eec007b781ed4830bf1870ba30.jpeg", alt: "코너 방수 작업" },
      { id: 5, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/547f0daf1f549c37abf4143e887422ea.jpeg", alt: "방수막 시공 완료" },
      { id: 6, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/d163e84a1cd87bf3c90774b69bb0ec2f.jpeg", alt: "배수 채널 설치" },
      { id: 7, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/fe5fffe5e72137c435717663edcbab5b.jpeg", alt: "바닥 타일 철거 및 배관 접근" },
      { id: 8, url: "https://public.readdy.ai/ai/img_res/1b9aab0848e675f1e42ad2cd3b83008f.jpg", alt: "방수 마감 완료" },
    ],
  },
  {
    label: "해빙 / 하수구막힘",
    photos: [
      { id: 1, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/16a2852fe391810b169fab9d7afc18cf.jpeg", alt: "맨홀 개방 작업" },
      { id: 2, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/d01c90c7eb4b7afce07cfbf2981da547.jpeg", alt: "하수구 청소 장비" },
      { id: 3, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/2091223e6bc8363af9b282a8527da9e1.jpeg", alt: "하수관 내부 점검" },
      { id: 4, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/e254de4e5aab4ca7c2165a8280aa0bd2.jpeg", alt: "동파 배관 수리" },
      { id: 5, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/af8daecb9cb554f1a552c1d40a93f1e1.jpeg", alt: "하수구 현장 작업" },
      { id: 6, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/95f99e426ef88e8da21ff9b0ac03efe6.jpeg", alt: "배관 드릴 작업" },
      { id: 7, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/a88e5e70ef5327ecf2ae7a0788711680.jpeg", alt: "오수정 내부 점검" },
      { id: 8, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/898613866d9e6e201c38ef77f2144610.jpeg", alt: "고압 청소 작업" },
    ],
  },
  {
    label: "피해복구",
    photos: [
      { id: 1, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/dd4f63e61df2e93e3447241fed212583.jpeg", alt: "욕실 타일 시공 완료" },
      { id: 2, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/910060b82b81c2526e7434648b14f09d.jpeg", alt: "레이저 수평 타일 시공" },
      { id: 3, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/1ad79703edcaa18ef63d6d3f4b822eda.jpeg", alt: "창문 주변 누수 피해 점검" },
      { id: 4, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/c1c6545594ab5a11abaf689e0e92a8b3.jpeg", alt: "균열 실링 작업" },
      { id: 5, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/1cbbda45efd085dd5553bb4b7189a7b2.jpeg", alt: "욕실 피해복구 완료" },
      { id: 6, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/00cc7bb3e5c2cec0c563179c193dba19.jpeg", alt: "타일 접착제 시공" },
      { id: 7, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/4663d976106acfbab3a4bbb66b96b915.jpeg", alt: "바닥 복구 작업" },
      { id: 8, url: "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/fd5562a83a33526f1d6ec95edcf67d6b.jpeg", alt: "줄눈 마감 작업" },
    ],
  },
];

interface LightboxState {
  categoryIndex: number;
  photoIndex: number;
}

export default function PortfolioSection() {
  const [lightbox, setLightbox] = useState<LightboxState | null>(null);

  const openLightbox = (categoryIndex: number, photoIndex: number) => {
    setLightbox({ categoryIndex, photoIndex });
  };

  const closeLightbox = () => setLightbox(null);

  const goPrev = useCallback(() => {
    if (!lightbox) return;
    const photos = categories[lightbox.categoryIndex].photos;
    setLightbox({
      ...lightbox,
      photoIndex: (lightbox.photoIndex - 1 + photos.length) % photos.length,
    });
  }, [lightbox]);

  const goNext = useCallback(() => {
    if (!lightbox) return;
    const photos = categories[lightbox.categoryIndex].photos;
    setLightbox({
      ...lightbox,
      photoIndex: (lightbox.photoIndex + 1) % photos.length,
    });
  }, [lightbox]);

  useEffect(() => {
    if (!lightbox) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "ArrowLeft") goPrev();
      if (e.key === "ArrowRight") goNext();
      if (e.key === "Escape") closeLightbox();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [lightbox, goPrev, goNext]);

  const currentPhoto =
    lightbox
      ? categories[lightbox.categoryIndex].photos[lightbox.photoIndex]
      : null;
  const currentCategory = lightbox ? categories[lightbox.categoryIndex] : null;

  return (
    <section id="portfolio" className="py-14 lg:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-4 lg:px-6">
        {/* Header */}
        <div className="text-center mb-10 lg:mb-14">
          <h2
            className="text-2xl lg:text-4xl font-black text-blue-600 mb-3 lg:mb-4"
            style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
          >
            착한누수 시공 사례
          </h2>
          <p className="text-zinc-500 text-xs lg:text-base">
            누수 탐지부터 보수 작업까지 실제 현장 시공 사례입니다.
          </p>
        </div>

        {/* Category Sections */}
        <div className="space-y-8 lg:space-y-12">
          {categories.map((cat, catIdx) => (
            <div key={cat.label}>
              <div className="bg-blue-600 px-4 lg:px-5 py-2.5 lg:py-3 mb-4 lg:mb-6 inline-flex items-center rounded-sm">
                <span className="text-white font-bold text-sm lg:text-base tracking-wide">
                  | {cat.label}
                </span>
              </div>
              <div className="bg-zinc-50 border border-zinc-200 rounded-xl p-3 lg:p-5">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 lg:gap-3">
                  {cat.photos.map((photo, photoIdx) => (
                    <div
                      key={photo.id}
                      className="overflow-hidden rounded-lg cursor-pointer group relative"
                      style={{ aspectRatio: "4/3" }}
                      onClick={() => openLightbox(catIdx, photoIdx)}
                    >
                      <img
                        src={photo.url}
                        alt={photo.alt}
                        className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
                        <div className="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center bg-white/80 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          <i className="ri-zoom-in-line text-zinc-700 text-base lg:text-lg" />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightbox && currentPhoto && currentCategory && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center"
          onClick={closeLightbox}
        >
          {/* Close */}
          <button
            className="absolute top-5 right-5 w-10 h-10 flex items-center justify-center text-white hover:text-zinc-300 transition-colors cursor-pointer z-10"
            onClick={closeLightbox}
          >
            <i className="ri-close-line text-3xl" />
          </button>

          {/* Category & Counter */}
          <div className="absolute top-5 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 z-10">
            <span className="text-white font-bold text-sm bg-blue-600 px-4 py-1 rounded-full whitespace-nowrap">
              {currentCategory.label}
            </span>
            <span className="text-zinc-400 text-xs">
              {lightbox.photoIndex + 1} / {currentCategory.photos.length}
            </span>
          </div>

          {/* Prev Button */}
          <button
            className="absolute left-5 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/25 rounded-full text-white transition-all cursor-pointer z-10"
            onClick={(e) => { e.stopPropagation(); goPrev(); }}
          >
            <i className="ri-arrow-left-s-line text-2xl" />
          </button>

          {/* Image */}
          <div
            className="max-w-4xl max-h-[80vh] mx-16"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={currentPhoto.url}
              alt={currentPhoto.alt}
              className="max-w-full max-h-[80vh] object-contain rounded-lg"
            />
            <p className="text-center text-zinc-400 text-sm mt-3">
              {currentPhoto.alt}
            </p>
          </div>

          {/* Next Button */}
          <button
            className="absolute right-5 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/25 rounded-full text-white transition-all cursor-pointer z-10"
            onClick={(e) => { e.stopPropagation(); goNext(); }}
          >
            <i className="ri-arrow-right-s-line text-2xl" />
          </button>

          {/* Thumbnail Strip */}
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2 overflow-x-auto max-w-2xl px-4">
            {currentCategory.photos.map((photo, idx) => (
              <button
                key={photo.id}
                onClick={(e) => {
                  e.stopPropagation();
                  setLightbox({ ...lightbox, photoIndex: idx });
                }}
                className={`flex-shrink-0 w-14 h-10 rounded overflow-hidden border-2 transition-all cursor-pointer ${
                  idx === lightbox.photoIndex
                    ? "border-blue-400 opacity-100"
                    : "border-transparent opacity-50 hover:opacity-80"
                }`}
              >
                <img
                  src={photo.url}
                  alt={photo.alt}
                  className="w-full h-full object-cover"
                />
              </button>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
